<template>
  <div class="ship-popup">
    <div class="cesium-popup-header flex justify-between align-center">
      <span>电子围栏信息</span>
      <ElButton circle size="small" @click="props.close">X</ElButton>
    </div>
    <table v-if="properties">
      <tbody>
        <tr v-for="item in tableData" :key="item.key">
          <td class="text-green-800">{{ item.key }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { dayjs, ElButton } from 'element-plus'
import type { EfenceVo } from '@/api/Api'

const props = defineProps<{
  properties: object
  close(): void
}>()
const properties = computed(() => {
  return props.properties as EfenceVo
})
const tableData = computed(() => {
  return [
    {
      key: '名称',
      value: properties.value.efenceName,
    },
    {
      key: '警戒区级别',
      value: properties.value.efenceLevel,
    },
    {
      key: '围栏类别',
      value: maptoZh_efenceType(properties.value.efenceType),
    },
    {
      key: '更新时间',
      value: dayjs(properties.value.updateTime).format('YYYY/MM/DD HH:mm:ss'),
    },
    {
      key: '更新用户ID',
      value: properties.value.updateUser,
    },
  ].filter((el) => el.value != undefined)
})
function maptoZh_efenceType(type: number) {
  switch (type) {
    case 1:
      return '进入事件'
    case 2:
      return '出离事件'
    default:
      return '未知：' + type
  }
}
</script>
